import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Btn, StatusPanel } from '../components/design-system';

const NewsletterConfirmation: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  const confirm = useCallback(async () => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid confirmation link.');
      return;
    }
    setStatus('loading');
    setMessage('');
    try {
      const res = await fetch(`/api/newsletter/confirm/${token}`, { method: 'POST' });
      if (!res.ok) throw new Error('Failed to confirm subscription');
      setStatus('success');
      setMessage('Your subscription has been confirmed. Thanks for subscribing.');
      setTimeout(() => navigate('/'), 3000);
    } catch {
      setStatus('error');
      setMessage('Failed to confirm subscription. The link may be invalid or expired.');
    }
  }, [token, navigate]);

  useEffect(() => {
    confirm();
  }, [confirm]);

  return (
    <StatusPanel title="newsletter · confirm" status={status} message={message}>
      {status !== 'loading' && (
        <div style={{ marginTop: 20, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {status === 'error' && (
            <Btn variant="ghost" onClick={confirm}>
              try again
            </Btn>
          )}
          <Btn variant="primary" to="/">
            back to home
          </Btn>
        </div>
      )}
    </StatusPanel>
  );
};

export default NewsletterConfirmation;
